// extracted by mini-css-extract-plugin
module.exports = {"component":"divider_component__HBpv2","asset":"divider_asset__jef_y"};